module.exports = __webpack_public_path__ + "static/media/vertical-banner-svgrepo-com.5b9db2f2.svg";